import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Button, ComponentSync, LL_H_C, LL_V_L, _className } from '@nu-art/thunderstorm-frontend/index';
import { Component_SearchAndResults } from '@app/styles';
import { Page_PathwayEditor } from '../Page_PathwayEditor.js';
import { AccessLevel, ModuleFE_PermissionsAssert } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
import { ICONS } from '@app/styles';
import { ModuleFE_Pathway } from '../../../_entity/pathway/index.js';
export class PathwaySelector_Search extends ComponentSync {
    //######################### Life Cycle #########################
    searchAndResultRef = React.createRef();
    pathwaySearchableItem = {
        ...Page_PathwayEditor.SearchableItem_PathwayV2,
        filter: (item) => !item.archived,
    };
    deriveStateFromProps(nextProps, state) {
        state.selectedItem = nextProps.selectedItem;
        state.archivedMode = false;
        return state;
    }
    //######################### Logic #########################
    onClickArchived = () => {
        const archivedMode = !this.state.archivedMode;
        this.pathwaySearchableItem.filter = (item) => item.archived === archivedMode;
        this.setState({ archivedMode });
        const component = this.searchAndResultRef.current;
        component?.onSearch(component?.state.searchTerm, true);
    };
    //######################### Render #########################
    renderAddPathwayButton = () => {
        const hasAccess = ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_Pathway.permissions.collection.edit) === AccessLevel.HasAccess;
        if (!hasAccess)
            return;
        return _jsx(Button, { variant: 'primary', className: 'button__create-new-pathway preferred-action', onClick: this.props.onCreateNewPathwayCallback, children: "Add Pathway" });
    };
    renderArchivedPathwaysButton = () => {
        const className = _className('button__archived', this.state.archivedMode && 'button__archived--active');
        return (_jsx(Button, { className: className, onClick: this.onClickArchived, children: _jsx(ICONS.archive.component, {}) }));
    };
    renderArchivedTitle = () => {
        if (!this.state.archivedMode)
            return;
        return _jsx("div", { className: 'archived-title', children: "Archived" });
    };
    render() {
        return _jsxs(LL_V_L, { id: 'pathway-selector__search', children: [_jsxs(LL_H_C, { className: 'pathway-selector__search__header', children: [this.renderArchivedTitle(), this.renderArchivedPathwaysButton(), this.renderAddPathwayButton()] }), _jsx(Component_SearchAndResults, { ref: this.searchAndResultRef, searchItems: [this.pathwaySearchableItem], selectedItem: this.state.selectedItem, onSearchItemSelected: (item) => this.props.onSearchItemSelected(item.id, item.type) })] });
    }
}
//# sourceMappingURL=PathwaySelector_Search.js.map